import React from "react";
import { useNavigate } from "react-router-dom";
import svg46 from "../../assets/svg/svg46.svg";
import svg47 from "../../assets/svg/svg47.svg";
import svg48 from "../../assets/svg/svg48.svg";
import svg49 from "../../assets/svg/svg49.svg";
import svg175 from "../../assets/svg/svg175.svg";

function BusinessType() {
  const navigate = useNavigate();
  const items = [
    {
      title: "Contractors",
      subtitle: "Pay crews fast & track every project cost",
      desc: "No cash handling, no leakages manage all site payments from one dashboard.",
      img: svg46,
      route: "/services/contractors",
    },
    {
      title: "Event Organizers",
      subtitle: "Pay staff & vendors without chaos",
      desc: "Disburse payments instantly before, during or after events, no confusion, no delays.",
      img: svg47,
      route: "/services/event-organizers",
    },
    {
      title: "SMEs & MSMEs",
      subtitle: "Run your business without money leaks",
      desc: "Automate payroll, expenses, & supplier payments, everything in one place.",
      img: svg48,
      route: "/services/msmes",
    },
    {
      title: "Enterprises",
      subtitle: "Full financial control at scale",
      desc: "Integrate with your ERP and track payments across departments in real time.",
      img: svg49,
      route: "/services/enterprises",
    },
  ];

  return (
    <div className="flex flex-col items-center">
      {/* Header */}
      <div className="text-ink text-center font-lexend text-[2.25rem] font-[500] leading-[2.625rem] tracking-[-0.0405rem]">
        Built for Businesses That Handle Money Daily
      </div>
      <div className="mt-[.75rem] text-center text-body font-lexend text-[1.125rem] font-[400] leading-[1.625rem] tracking-[-0.0135rem] max-w-[47rem]">
        Used by contractors, events teams, and businesses across Kenya to
        eliminate payment delays and fraud.
      </div>

      {/* Cards */}
      <div className="mt-[3rem] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[1.5rem] w-full">
        {items?.map((item, index) => (
          <div
            key={index}
            onClick={() => item.route && navigate(item.route)}
            className={`flex flex-col rounded-[1.25rem] bg-white shadow-[0_2px_10px_0_rgba(35,31,32,0.10)] p-[1.5rem] ${item.route ? "cursor-pointer" : ""}`}
          >
            <img
              src={item.img}
              alt={item.title}
              className="w-full h-[9rem] object-cover rounded-[0.75rem]"
            />

            <div className="mt-[1.12rem] text-ink font-lexend text-[1.25rem] font-[600] leading-[1.75rem]">
              {item.title}
            </div>

            <div className="mt-[.75rem] text-ink font-lexend text-[.875rem] font-[500] leading-[1.20313rem]">
              {item.subtitle}
            </div>

            <div className="mt-[.92rem] flex-1 text-body font-lexend text-[.875rem] font-[300] leading-[1.42188rem]">
              {item.desc}
            </div>

            <div className="mt-[1rem] flex items-center gap-[.375rem]">
              <span
                className="font-lexend text-[.875rem] font-[500] leading-[1.25rem]"
                style={{
                  background: "linear-gradient(180deg, #F7941D 0%, #E8202D 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                View More
              </span>
              <img src={svg175} alt="arrow" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BusinessType;
